import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

/**
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 * This component handles the OAuth callback from Emergent Auth
 */
const GoogleAuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogle } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processGoogleAuth = async () => {
      // Extract session_id from URL hash
      const hash = location.hash;
      const sessionIdMatch = hash.match(/session_id=([^&]+)/);
      
      if (!sessionIdMatch) {
        console.error('No session_id found in URL');
        navigate('/login?error=no_session');
        return;
      }

      const sessionId = sessionIdMatch[1];
      console.log('Processing Google OAuth session:', sessionId.substring(0, 20) + '...');

      try {
        const result = await loginWithGoogle(sessionId);
        
        if (result.success) {
          console.log('Google login successful');
          // Redirect to dashboard
          navigate('/', { replace: true, state: { user: result.user } });
        } else {
          console.error('Google login failed:', result.error);
          navigate('/login?error=' + encodeURIComponent(result.error || 'google_auth_failed'));
        }
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/login?error=google_auth_failed');
      }
    };

    processGoogleAuth();
  }, [location.hash, loginWithGoogle, navigate]);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#0b0e11',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      color: '#fff',
    }}>
      <div style={{
        width: '48px',
        height: '48px',
        border: '3px solid #f0b90b',
        borderTopColor: 'transparent',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
      }} />
      <p style={{ marginTop: '16px', color: '#848e9c' }}>
        Авторизация через Google...
      </p>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default GoogleAuthCallback;
